var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "fit-content" },
    [
      _c(
        "div",
        { staticStyle: { display: "flex" } },
        _vm._l(_vm.upElementBlocks, function(item, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass: "section form-column",
              style: { width: item.width + "px" }
            },
            [
              _c("span", { staticClass: "title" }, [
                _vm._v(_vm._s(item.title))
              ]),
              _vm._l(item.elementNames, function(elementName) {
                return [
                  _vm._t(elementName),
                  elementName === "jobNo"
                    ? [_vm._t("saleProductCode"), _vm._t("fullOrInside")]
                    : _vm._e()
                ]
              })
            ],
            2
          )
        }),
        0
      ),
      _vm._l(_vm.downElementBlocks, function(item, index) {
        return [
          item.name === "cargoInfo" || item.name === "CargoInformation"
            ? _c(
                "div",
                { key: index, staticStyle: { "flex-direction": "column" } },
                [
                  _c("div", { staticClass: "section" }, [
                    _c("span", { staticClass: "title" }, [
                      _vm._v(_vm._s(item.title))
                    ]),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          width: "1100px",
                          display: "flex",
                          "flex-wrap": "wrap"
                        }
                      },
                      [
                        _vm._t("goodsInfo"),
                        _vm._l(item.elementNames, function(elementName, index) {
                          return [
                            _vm.lineBreak.hasOwnProperty(elementName) &&
                            _vm.lineBreak[elementName]
                              ? [
                                  _c("div", {
                                    key: index,
                                    staticStyle: { width: "100%" }
                                  })
                                ]
                              : _vm._e(),
                            _vm._t(elementName)
                          ]
                        })
                      ],
                      2
                    )
                  ])
                ]
              )
            : item.name === "customerDeliveryInfo" ||
              item.name === "CustomerShippingInformation"
            ? _c(
                "div",
                {
                  key: index,
                  staticClass: "section",
                  staticStyle: { width: "100%" }
                },
                [
                  _c("span", { staticClass: "title" }, [
                    _vm._v(_vm._s(item.title))
                  ]),
                  _vm._t("codeSearching"),
                  _c(
                    "div",
                    {
                      staticClass: "form-row",
                      staticStyle: {
                        display: "flex",
                        "flex-direction": "row",
                        "margin-top": "8px"
                      }
                    },
                    [
                      _vm._l(item.elementNames, function(elementName) {
                        return _vm._t(elementName)
                      })
                    ],
                    2
                  )
                ],
                2
              )
            : _vm._e()
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }